import React, { useContext } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { List, Breadcrumbs, Grid, Typography } from '@material-ui/core';

import { useBreadcrumbs } from './breadcrumbs-hook';
import { BreadcrumbsCtx } from './breadcrumbs-ctx';
import { useStyles } from './portfolio-styles';
import { usePortfolioItems } from './portfolio-items-hook';
import { PortfolioListItem } from './portfolio-list-item';
import { AuthCtx } from 'components/auth/auth-ctx';

export function Portfolio({ children }: { children?: React.ReactNode }) {
  const classes = useStyles();
  const history = useHistory();

  const { breadcrumbs, setBreadcrumbs } = useBreadcrumbs();

  const portfolioItems = usePortfolioItems();
  const authCtx = useContext(AuthCtx);

  if (authCtx.userLoaded && !authCtx.userInfo) {
    history.replace('/prihlaseni');
  }

  if (!authCtx.userLoaded) {
    return null;
  }

  return (
    <BreadcrumbsCtx.Provider
      value={{
        breadcrumbs,
        setBreadcrumbs,
      }}
    >
      <Grid container className={classes.root}>
        <Grid item md={2} sm={4} xs={12}>
          <List component="nav" dense={true} className={classes.navigation}>
            {portfolioItems.map((item) => (
              <PortfolioListItem
                breadcrumbKey={item.key}
                selected={breadcrumbs?.[1]?.key}
                classes={classes}
                history={history}
                {...item}
              />
            ))}
          </List>
        </Grid>
        <Grid item md={10} sm={8} xs={12}>
          <Breadcrumbs
            separator="›"
            aria-label="breadcrumb"
            // className={classes.breadcrumbs}
            classes={{ root: classes.breadcrumbs }}
          >
            {breadcrumbs.length > 0 &&
              breadcrumbs.map((b) =>
                b.to ? (
                  <Link to={b.to} key={b.key}>
                    <Typography color="primary">{b.title}</Typography>
                  </Link>
                ) : (
                  <Typography color="textPrimary" key={b.key}>
                    {b.title}
                  </Typography>
                )
              )}
          </Breadcrumbs>
          {children}
        </Grid>
      </Grid>
    </BreadcrumbsCtx.Provider>
  );
}
